<template>
  <div class="row mt-5 justify-content-between">
    <div class="col-sm-3" v-if="checkForPermission(add_sales_profile_ownership_permission)">
      <h4 class="card-title mb-3">Transfer customer to another staff member</h4>
      <form @submit.prevent="changeOwnership">
        <div class="row">
          <div class="col-12 mt-3">
            <label>New Owner</label>
            <multiselect v-model="last_visit" :options="users.objects" placeholder="Select one" label="name" track-by="name"
                         :class="{'is-invalid': v$.last_visit.$error}" :searchable="true" :internal-search="false" @search-change="asyncFindUser">
              <span slot="noResult">No user found. Change search query.</span>
            </multiselect>
            <p
                v-for="error of v$.last_visit.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>
          <div class="mt-3 col-12">
            <b-button variant="info" size="lg" class="py-2 text-white w-100" disabled v-if="customerLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button variant="info" size="lg" class="py-2 text-white w-100 text-white" type="submit" v-else>
              Change Ownership
            </b-button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-7">
      <data-table :columns="columns" :rows="ownership"/>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DataTable from "@/components/data-table";
import {mapActions, mapGetters} from "vuex";
import {required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {SYSTEM_USERS} from "@/gql";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";
export default {
name: "ownership",
  components: {
    DataTable,
    Multiselect
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      last_visit: "",
      userSearchKeyword: "",
      add_sales_profile_ownership_permission: permissions.add_sales_profile_ownership_permission,
      columns:[
        {
          field: 'newOwner',
          label: 'Current Owner'
        },
        {
          field: 'lastUpdatedBy',
          label: 'Changed By'
        },
        {
          field: 'createdAt',
          label: 'Changed On'
        }
      ],
      users: {
        objects: []
      }
    }
  },
  props: {
    ownership : {
      type: Array,
    }
  },
  validations () {
    return {
      last_visit: {required},
    }
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  apollo: {
    users: {
      query: SYSTEM_USERS,
      variables(){
        return {
          page: 1,
          perPage: 30,
          isStaff: true,
          searchKeyword: this.userSearchKeyword
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addNewOwner: 'customers/changeSalesProfileOwnership',
    }),
    async changeOwnership() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        feedback: this.$route.params.id,
        userId: this.last_visit.publicId,
      }
      await this.addNewOwner(data).then(resp => {
        this.$emit('updateProfile')
        if(resp.publicId){
          successToast(`New Owner added successfully`)
        }
      })

      this.v$.$touch();
    },
    asyncFindUser (query) {
      this.userSearchKeyword = query
    }
  }
}
</script>

<style scoped>

</style>
